import React from 'react';
import { IWizardData } from '../../../types/iwizard-data';
import { InfoProps } from './info';
import { getDisplayLabel } from '../../../utils/artDetailsUtils';
import { renderValue } from '../../../components/cardDetails/valueRender';

// Styles
import styles from './../art-details.module.css'; // index.tsx

interface PrintArtDetailsProps {
  title: string;
  properties?: { key: keyof InfoProps; label: string }[];
  wizardDocData: IWizardData;
  data?: Record<string, unknown>;
  productType?: string;
}

const PrintArtDetails: React.FC<PrintArtDetailsProps> = ({ title, properties = [], wizardDocData, data, productType = '' }) => {
  const hiddenDetailKeys = new Set([
    'extendedDescription',
    'extendedDescriptionHTML',
    'extendedDescriptionHtml',
  ]);

  const getFallbackLabel = (key: string) =>
    key.replace(/([A-Z])/g, ' $1').replace(/^./, character => character.toUpperCase());

  const renderProperty = (key: string, label: string, value: unknown, index: number) => {
    const displayValue = renderValue(value);

    if (displayValue === null) {
      return null;
    }

    return (
      <div className={styles.artDetails} key={index}>
        <span className={styles.name}>{key === 'quantities' && typeof value === 'object' ? 'Total Quantity' : label}:</span>
        <span className={styles.value}>
          {key === 'aspectRatio' && typeof value === 'number' && Number.isFinite(value)
            ? value.toFixed(2)
            : key === 'quantities' && value && typeof value === 'object'
              ? Object.values(value).reduce((sum, quantity) => sum + (Number(quantity) || 0), 0).toString()
              : displayValue}
        </span>
      </div>
    );
  };

  const details = data
    ? Object.entries(data)
      .filter(([key]) => !hiddenDetailKeys.has(key))
      .map(([key, value]) => {
        const property = properties.find(item => item.key === key);
        return {
          key,
          label: getDisplayLabel(key, property?.label ?? getFallbackLabel(key), productType),
          value,
        };
      })
    : properties.map(property => ({
      key: String(property.key),
      label: property.label,
      value: wizardDocData[property.key as keyof typeof wizardDocData],
    }));

  const count = details.filter(detail => renderValue(detail.value) !== null).length;

  if (count === 0)
    return null
  else
    return (
      <div>
        <div className={styles.title}>{title}</div>
        {details.map((detail, index) => renderProperty(detail.key, detail.label, detail.value, index))}
      </div>
    );
};

export default PrintArtDetails;
